import { Dialogo } from './piezas.js';

/**
 * QR para el celular. En la app móvil no se pueden bajar archivos ni abrir la hoja de
 * impresión, así que la imagen se muestra y se guarda o comparte con una pulsación larga.
 */
export function VisorQr({
  imagen,
  titulo,
  alCerrar,
}: {
  imagen: string;
  titulo: string;
  alCerrar: () => void;
}): JSX.Element {
  return (
    <Dialogo titulo={titulo} ancho={560} alCerrar={alCerrar}>
      <p className="campo-nota">Mantenga presionada la imagen y elija «Guardar imagen» o «Compartir».</p>
      <img
        src={imagen}
        alt={titulo}
        style={{ width: '100%', height: 'auto', borderRadius: 8, background: '#fff', display: 'block' }}
      />
    </Dialogo>
  );
}
